import React, { lazy, Suspense } from "react";
const Module = lazy(() => import("./ElectronicSignatures"));
const Public = lazy(() => import("./PublicSigning"));
const Validator = lazy(() => import("./ValidateDocument"));
const Field = lazy(() => import("./SignatureField"));
const Waiting = () => <p role="status">Carregando assinaturas…</p>;
export const ElectronicSignaturesRoute = (props) => (
  <Suspense fallback={<Waiting />}>
    <Module {...props} />
  </Suspense>
);
export const PublicSigningRoute = (props) => (
  <Suspense fallback={<Waiting />}>
    <Public {...props} />
  </Suspense>
);
export const ValidateDocumentRoute = (props) => (
  <Suspense fallback={<Waiting />}>
    <Validator {...props} />
  </Suspense>
);
export const SignatureFieldRoute = (props) => (
  <Suspense fallback={<Waiting />}>
    <Field {...props} />
  </Suspense>
);
